module.exports = {
  // proApiHost:'https://oaapi.tmi.com.vn/',

  // devApiHost: "http://161.117.34.230:1000/",
  devApiHost: "http://192.168.3.9:8100/",
  // proApiHost: "http://161.117.34.230:1000/",
  proApiHost: "http://192.168.3.9:8100/",
  releaseApiHost: "https://oaapi.tmi.com.vn/",
  tmkReleaseApiHost: "http://172.16.0.17:8100/",
  // tmkReleaseApiHost: "https://purapitmv.tmi.com.vn/",
  // tmkReleaseApiHost: "https://purapievn.tmi.com.vn/",

  // devSignalrHost: "http://161.117.34.230:1000/signalr",
  devSignalrHost: "http://192.168.3.9:8100/signalr",
  // proSignalrHost: "http://161.117.34.230:1000/signalr",
  proSignalrHost: "http://192.168.3.9:8100/signalr",
  releaseSignalrHost: "https://oaapi.tmi.com.vn/signalr",
  tmkReleaseSignalrHost: "http://172.16.0.17:8100/signalr",
  // tmkReleaseSignalrHost: "https://purapitmv.tmi.com.vn/signalr",
  // tmkReleaseSignalrHost: "https://purapievn.tmi.com.vn/signalr",

  // devReportHost: "http://161.117.34.230:1000/",
  // proReportHost: "http://161.117.34.230:1000/"

  devReportHost: "http://192.168.3.9:8100/",
  proReportHost: "http://192.168.3.9:8100/"
};



// WEBPACK FOOTER //
// ./src/utils/config.js